import { useState } from 'react';
import { View, TextInput, FlatList, Text, StyleSheet, ScrollView, TouchableOpacity, Modal } from 'react-native';
import { useExercises, useMuscleGroups } from '@/hooks/useExercises';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import { ExerciseCard } from '@/components/ExerciseCard';
import { LibraryDesktop } from '@/components/LibraryDesktop';
import { VideoPlayer } from '@/components/VideoPlayer';
import { Exercise } from '@/lib/types';

export default function LibraryScreen() {
  const isDesktop = useIsDesktop();
  const [search, setSearch] = useState('');
  const [muscleGroup, setMuscleGroup] = useState<string | undefined>();
  const [selected, setSelected] = useState<Exercise | null>(null);
  const { exercises } = useExercises({ search, muscleGroup });
  const { groups: muscleGroups } = useMuscleGroups();

  if (isDesktop) return <LibraryDesktop />;

  return (
    <View style={styles.container}>
      <TextInput
        style={styles.search}
        placeholder="Buscar exercício..."
        value={search}
        onChangeText={setSearch}
      />
      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        style={styles.filters}
        contentContainerStyle={styles.filtersContent}
      >
        <TouchableOpacity
          style={[styles.chip, !muscleGroup && styles.chipActive]}
          onPress={() => setMuscleGroup(undefined)}
        >
          <Text style={[styles.chipText, !muscleGroup && styles.chipTextActive]}>Todos</Text>
        </TouchableOpacity>
        {muscleGroups.map(g => (
          <TouchableOpacity
            key={g}
            style={[styles.chip, muscleGroup === g && styles.chipActive]}
            onPress={() => setMuscleGroup(g)}
          >
            <Text style={[styles.chipText, muscleGroup === g && styles.chipTextActive]}>{g}</Text>
          </TouchableOpacity>
        ))}
      </ScrollView>
      <FlatList
        data={exercises}
        keyExtractor={e => e.id}
        renderItem={({ item }) => <ExerciseCard exercise={item} onPress={setSelected} actionLabel="Ver" />}
        contentContainerStyle={{ padding: 16 }}
      />
      <Modal visible={!!selected} animationType="slide" onRequestClose={() => setSelected(null)}>
        {selected && (
          <View style={styles.modal}>
            <VideoPlayer uri={selected.video_url} thumbnailUri={selected.thumbnail_url} autoPlay />
            <Text style={styles.modalName}>{selected.name}</Text>
            <Text style={styles.modalMuscle}>{selected.muscle_group}</Text>
            {selected.description && <Text style={styles.modalDesc}>{selected.description}</Text>}
            <TouchableOpacity style={styles.closeBtn} onPress={() => setSelected(null)}>
              <Text style={styles.closeBtnText}>Fechar</Text>
            </TouchableOpacity>
          </View>
        )}
      </Modal>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: '#F5F5F5' },
  search: { margin: 16, marginBottom: 8, padding: 12, backgroundColor: '#fff', borderRadius: 8, borderWidth: 1, borderColor: '#eee', fontSize: 15, color: '#1A1A1A' },
  filters: { marginBottom: 8, flexGrow: 0, minHeight: 54, maxHeight: 54 },
  filtersContent: { paddingHorizontal: 16, paddingVertical: 10, gap: 8, alignItems: 'center' },
  chip: {
    paddingHorizontal: 14,
    paddingVertical: 8,
    borderRadius: 20,
    backgroundColor: '#eee',
    minHeight: 34,
    justifyContent: 'center',
  },
  chipActive: { backgroundColor: '#C8102E' },
  chipText: { color: '#555', fontSize: 13 },
  chipTextActive: { color: '#fff' },
  modal: { flex: 1, padding: 20, backgroundColor: '#fff' },
  modalName: { fontSize: 22, fontWeight: 'bold', marginTop: 16, color: '#1A1A1A' },
  modalMuscle: { fontSize: 14, color: '#888888', marginTop: 4 },
  modalDesc: { fontSize: 15, color: '#444', marginTop: 12, lineHeight: 22 },
  closeBtn: { marginTop: 24, backgroundColor: '#C8102E', padding: 14, borderRadius: 8, alignItems: 'center' },
  closeBtnText: { color: '#fff', fontWeight: 'bold', fontSize: 16 },
});
